module.exports = __webpack_public_path__ + "img/solution-domainHIL-system-pic.8d573ce9.png";